<template>
  <v-dialog
    v-model="dialog"
    width="800px">
    <div class="dialog-container">
      <div class="dialog-header">
        <h2>New Endorsement Support Ticket</h2>
        <div class="btn-container">
          <v-button
            size="small"
            @click="dialog = false">Cancel</v-button>
          <v-button
            size="small"
            type="primary"
            @click="handlerCreate">Create</v-button>
        </div>
      </div>
      <el-form
        ref="form"
        :model="formData"
        :rules="rules">
        <div class="dialog-content flex">
          <div class="left">
            <div class="form-item">
              <span>Assignee</span>
              <el-form-item prop="assignee_id">
                <v-select
                  v-model="formData.assignee_id"
                  :list="globalOptions.assignee" />
              </el-form-item>
            </div>
            <div
              v-if="!isFina&&!isGuestTravel"
              class="form-item">
              <span>Customer</span>
              <template v-if="!isEnquiry">
                <el-form-item prop="customer_id">
                  <el-select
                    v-if="!!form.customer_id"
                    v-model="customer.isrd_nm"
                    disabled
                    size="small"
                  >
                    <el-option
                      :label="customer.isrd_nm"
                      :value="customer.isrd_nm"></el-option>
                  </el-select>
                  <v-select
                    v-else
                    v-model="formData.customer_id"
                    remote
                    nameGroup
                    :remoteMethod="remoteMethodUser"
                    :list="customerOptionsUser"
                    :disabled="true"
                    :clearable="true"
                    @change="changeCustomer"
                  />
                </el-form-item>
              </template>
              <template v-else>
                <v-input
                  disabled
                  :value="form.name"></v-input>
              </template>
            </div>
            <div class="form-item">
              <span>Policy</span>
              <v-autocomplete
                v-if="!isEnquiry"
                v-model="formData.pcy_id"
                :disabled="true"
                labelKey="pcy_id"
                valueKey="pcy_id"
                :list="customerPolicyList"/>
              <v-input
                v-else
                disabled
                :value="form.pcy_no"></v-input>
            </div>
            <div class="form-item">
              <span>Contact Number</span>
              <el-form-item prop="contact_no">
                <v-input v-model="formData.contact_no"/>
              </el-form-item>
            </div>
            <!--            <div-->
            <!--              v-if="!isEnquiry"-->
            <!--              class="form-item">-->
            <!--              <span>Preferred Time for Call-back</span>-->
            <!--              <el-form-item prop="preferred_time">-->
            <!--                <v-select-->
            <!--                  v-model="formData.preferred_time"-->
            <!--                  :list="globalOptions.call_back_preferred_time" />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
            <!-- <div class="form-item">
            <span>Effective Date</span>
            <v-date-picker v-model="formData.preferred_time" />
          </div> -->
            <h3>Endorsement Type</h3>
            <div class="form-item">
              <span>Action</span>
              <el-form-item prop="action">
                <v-radio-group
                  v-model="formData.action"
                  :button="true"
                  :list="actionOption" />
              </el-form-item>
            </div>
            <!--            <div-->
            <!--              v-if="formData.action==1"-->
            <!--              class="form-item">-->
            <!--              <el-form-item-->
            <!--                prop="charge_id"-->
            <!--                :rules="rules.select">-->
            <!--                <v-radio-group-->
            <!--                  v-model="formData.charge_id"-->
            <!--                  border-->
            <!--                  :list="endorseChangeTypeOptions" />-->
            <!--              </el-form-item>-->
            <!--            </div>-->
          </div>
          <div class="right">
            <div class="form-item">
              <span>Message</span>
              <v-input
                v-model="formData.message"
                type="textarea"
                :rows="9" />
            </div>
            <h3>Documents</h3>
            <div class="mg-b-15">
              <v-button
                type="warning"
                @click="downloadCancelForm">Download Cancellation Form</v-button>
            </div>

            <section v-if="formData.other_file.length > 0">
              <file-container
                v-for="(item, index) in formData.other_file"
                :key="index"
                :fileData="item"
                :edit="true"
                :otherData="{
                  index
                }"
                @uploadSuccess="handlerUploadSuccess"
                @delete="deleteOtherFile">
              <!-- document{{ index+1 }} -->
              </file-container>
            </section>
            <!-- <section v-show="formData.action === 2 && cancelFileData.id">
            <file-container
              :fileData="cancelFileData"
              :edit="true"
              @uploadSuccess="handlerUploadSuccess"
              @delete="deleteCancelFile" />
          </section> -->
            <v-upload
              @uploadSuccess="handlerUploadSuccess" />
          </div>
        </div>
      </el-form>
    </div>
  </v-dialog>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import { createEndorsementTicket, getCustomerPolicy, getCancelForm } from '@/api/ticket'
import FileContainer from '@/views/components/file-container'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
export default {
  name: 'NewEndorsementTicket',
  components: {
    FileContainer
  },
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: [Object,Array],
      default: () => ({})
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    isEnquiry: {
      type: Boolean,  // 創建完是否跳轉 ticket 詳情
      default: false
    }
  },
  data() {
    return {
      dialog:false,
      customerPolicyList: [],
      actionOption: [
        {
          name: 'Endorsement',
          id: 1
        },
        {
          name: 'Cancellation',
          id: 2
        }
      ],
      formData: {
        assignee_id: '',
        customer_id: '',
        pcy_id: '',
        preferred_time: '',
        action: 1,
        insurance_claim_ind: '',
        change_policy_holder_ind: '',
        change_driver_ind: '',
        change_car_ind: '',
        other_ind: '',
        change_policy_period_ind: '',
        contact_no: '',
        // cancel_form_path: '',
        // cancel_form_path_id: '',
        // other_file_1_path: '',
        // other_file_1_path_id: '',
        other_file: [],
        merchant_platform:'',
        // charge_id:''
      },
      cancelFileData: {},
      otherFileList: [],
      cancelFormUrl: '', // cancel form 模板
    }
  },
  computed: {
    ...mapState('common', ['customerOptionsPhone','customerOptionsUser','customerOptionsEmail']),

    maskForm() {
      return this.formData.action === 2
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform == 2
    },
    productId(){
      let {product_id} = this.$route.query
      return product_id
    },
    isGuestTravel(){
      let {is_guest_order} = this.form||{}
      return is_guest_order==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = Object.assign(this.formData, val)
        if(this.isEnquiry){
          let {phone} = val||{}
          this.formData.contact_no = phone
        }
      }
    },
    // 'formData.customer_id': {
    //   // immediate: true,
    //   handler(val) {
    //     if(val) {
    //       this.handlerChangeCustomer(val)
    //     }
    //   }
    // }
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsEmail','getCustomerOptionsUser']),

    remoteMethodUser(query) {
      if (query !== '') {
        this.getCustomerOptionsUser(query)
      } else {
        this.setCustomerOptionNUll()
      }
    },
    changeDialog() {
      if(this.isFina){
        this.dialog = !this.dialog
        return
      }
      if(this.formData.customer_id && this.customerPolicyList.length < 1) {
        this.handlerChangeCustomer(this.formData.customer_id)
      }
      this.dialog = !this.dialog
    },
    changeCustomer(id) {
      this.handlerChangeCustomer(id)
    },
    handlerChangeCustomer(id) {
      if(id) {
        this.network().getCustomerPolicy(id)
      }
    },
    deleteOtherFile({ index }) {
      this.formData.other_file.splice(index, 1)
    },
    handlerCreate() {
      // 處理 other file
      // const otherData = this.otherFileList.reduce((result, item, index) => {
      //   result[`other_file_${index+1}_path`] = item.name
      //   result[`other_file_${index+1}_path_id`] = item.id
      //   return result
      // }, {})
      this.$refs.form.validate(valid => {
        if(valid) {
          this.network().createEndorsementTicket({
            ...this.formData,
            // ...otherData
          })
          this.setCustomerOptionNUll()
        }
      })

    },
    // 上傳完文件
    handlerUploadSuccess({ data, otherData }) {
      const { index = '' } = otherData
      const { name, id } = data
      if(index !== '') {
        this.$set(this.formData.other_file, index, data)
      }
      else {
        this.formData.other_file.push(data)
      }
    },
    async downloadCancelForm() {
      if(!this.cancelFormUrl) {
        await this.network().getCancelForm()
      }
      window.open(this.cancelFormUrl, '_blank')
    },
    network() {
      return {
        createEndorsementTicket: async (params) => {
          if(this.isFina){
            delete params.customer_id
          }
          if(this.isEnquiry){
            let {id} = this.$route.query
            params.enquiry_id = id
            delete params.id
          }
          const { data } = await createEndorsementTicket({
            ...params,
            order_id: this.orderId,
            // charge_id:1
          })
          this.changeDialog()
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.id
            }
          })
        },
        getCustomerPolicy: async id => {
          const { data } = await getCustomerPolicy({
            customer_id: id
          })
          this.customerPolicyList = data.policy
        },
        getCancelForm: async () => {
          let res = await getCancelForm({order_id: this.orderId})
          downloadFile(res)
          // this.cancelFormUrl = data.download_url
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    color: #616266;
    // h2 {
    //   font-size: 24px;
    // }
    h3 {
        padding-bottom: 5px;
    }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      h1 {
        font-size: 24px;
      }
    }
    .dialog-content {
      padding-top: 15px;
      & > div {
        flex: 1;
      }
      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }
      .right {
        padding-left: 15px;
      }
    }
  }
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
  .el-input__suffix-inner{
    i{
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
